// extracted by mini-css-extract-plugin
var _1 = "BirdviewChartCard-moduleasOfNow__ZOLz6";
var _2 = "BirdviewChartCard-modulebody__mz7eq";
var _3 = "BirdviewChartCard-modulechart__NS6xx";
var _4 = "BirdviewChartCard-modulecontrols__MM4ma";
export { _1 as "asOfNow", _2 as "body", _3 as "chart", _4 as "controls" }
